import { GridColDef, GridExpandMoreIcon } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import {
  Accordion,
  AccordionSummary,
  GKClientDataGrid,
  StatusField,
  Typography,
} from "components";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

const ExecutedOrder = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["GET_EXECUTED_ORDERS"],
    queryFn: () => axiosInstance.get(`/super_admin/unique-orders/`),
  });

  const orders: GridColDef[] = [
    {
      ...extraColumnsField("Count", "count", 150, 1),
      valueGetter: (row) => row?.row?.count || "-",
    },
    {
      ...extraColumnsField("Order Id", "orderId", 150, 1),
      valueGetter: (row) => row?.row?.orderId || "-",
    },
    {
      ...extraColumnsField("Smallcase Status", "smallcaseStatus", 150, 1),
      renderCell: (params) => (
        <StatusField statusString={params?.row?.smallcaseStatus || "-"} />
      ),
    },
    {
      ...extraColumnsField("Transaction Type", "transactionType", 150, 1),
    },
  ];

  return (
    <Accordion
      disableGutters
      style={{
        border: `solid 1px var(--neutral-100)`,
        borderRadius: "8px",
        boxShadow: "none",
        background: "none",
      }}
    >
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        sx={{
          "& .MuiAccordionSummary-content": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          },
        }}
      >
        <Typography
          fontSize={16}
          fontWeight={600}
          textTransform={"none"}
          color={"var(--primary-900)"}
        >
          Executed Order
        </Typography>
      </AccordionSummary>
      <GKClientDataGrid
        loading={isLoading}
        columns={orders}
        rows={data?.data?.data}
        showFiltersButton={false}
      />
    </Accordion>
  );
};

export default ExecutedOrder;
